import React, {
  FC,
  useMemo,
}                           from 'react';
import { ICreditUnion }     from '@typings/accountManagement';
import { ILinkButtonData }  from '@typings/components';
import { EAppPage }         from '@enums/common';
import { EAccountPage }     from '@enums/accountManagement';
import { PageWrapper }      from '@components/index';

interface IProps {
  push     : (path: string) => void;
  cuInfo   : ICreditUnion | null;
  isWhite? : boolean;
}

export const AccountPageWrapper: FC<IProps> = ({
  push,
  cuInfo,
  isWhite = false,
  children,
}) => {
  const navLinksData = useMemo<ILinkButtonData[]>(
    () => {
      const searchLinkData: ILinkButtonData = {
        label   : 'Return to Account Management',
        onClick : (): void => push(`${EAppPage.AccountManagement}/${EAccountPage.Search}`),
      };

      const accountInfoLinkData: ILinkButtonData | null = cuInfo
        ? {
          label   : `Return to ${cuInfo.name}`,
          onClick : (): void => push(`${EAppPage.AccountManagement}/${cuInfo.cuid}/${EAccountPage.Edit}`),
        }
        : null;

      return [
        searchLinkData,
        ...(accountInfoLinkData ? [accountInfoLinkData] : []),
      ];
    },
    [cuInfo, push],
  );

  return (
    <>
      <PageWrapper
        isWhite      = {isWhite}
        navLinksData = {navLinksData}
      >
        {children}
      </PageWrapper>
    </>
  );
};
